// import AsyncCreateableSelect from "./AsyncCreatableSelect";
import Select from "./Select";
import { useCollection } from "@nandorojo/swr-firestore";
import { Loader } from 'react-bulma-components'

const CompanySelect = props => {
  const companiesData = useCollection("companies", {
    where: ["isActive", "==", true]
  });
  if (companiesData.error) {
    return <p>{companiesData.error}</p>;
    console.error(companiesData.error);
  }
  const companyOptions = companiesData?.data?.map(company => {
    return {
      label: `${company.name}`,
      value: company.id
    };
  });
  return (
    companiesData.loading ?
      (
        <Loader />
      ) : (
        <Select
          options={companyOptions}
          isMulti={false}
          isCreatable={false}
          {...props}
        />
      )
  );
};

export default CompanySelect;
